import { Box, Link, Stack, Typography } from "@mui/material";
import contactConstants from "../data/contact.json";
import PlaceIcon from "@mui/icons-material/Place";
import EmailIcon from "@mui/icons-material/Email";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import CallIcon from "@mui/icons-material/Call";
import PageHeader from "../components/PageHeader";
import { motion } from "framer-motion";

type Props = {};

const ContactUs = (props: Props) => {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      alignItems="center"
      justifyContent="space-between"
      spacing={{ xs: 4, md: 8 }}
      p={2}
    >
      <Stack
        p={{ xs: 1, sm: 0 }}
        direction="column"
        alignItems="flex-start"
        spacing={2}
      >
        <Typography
          variant="body2"
          sx={{ fontFamily: "inherit" }}
          textAlign="justify"
          color={"customColors.clr1"}
          component={motion.div}
          initial={{ x: -100, opacity: 0 }}
          whileInView={{
            x: 0,
            opacity: 1,
            transition: { duration: 0.2 },
          }}
        >
          {contactConstants?.subtitle}
        </Typography>
        <PageHeader title={`${contactConstants?.title}`} />
        <Typography
          sx={{ fontFamily: "inherit" }}
          variant="body2"
          textAlign="justify"
          component={motion.div}
          initial={{ scale: 0 }}
          whileInView={{
            scale: 1,
            transition: { duration: 0.2, delay: 0.2 },
          }}
        >
          {contactConstants?.description[0]}
          <br />
          {contactConstants?.description[1]}
        </Typography>
        <Typography
          variant="body2"
          textAlign="justify"
          component={motion.div}
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            fontFamily: "inherit",
            gap: 2,
          }}
          initial={{ x: -100, opacity: 0 }}
          whileInView={{
            x: 0,
            opacity: 1,
            transition: { duration: 0.2, delay: 0.2 },
          }}
        >
          <PlaceIcon fontSize="small" />
          <span style={{ padding: "0px !important" }}>
            {contactConstants?.address}
          </span>
        </Typography>
        <Typography
          variant="body2"
          textAlign="justify"
          component={motion.div}
          sx={{
            fontFamily: "inherit",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 2,
          }}
          initial={{ x: -100, opacity: 0 }}
          whileInView={{
            x: 0,
            opacity: 1,
            transition: { duration: 0.2, delay: 0.4 },
          }}
        >
          <CallIcon fontSize="small" />
          <Link href={`tel:${contactConstants?.telephone}`} underline="hover">
            {contactConstants?.telephone}
          </Link>
        </Typography>
        <Typography
          variant="body2"
          textAlign="justify"
          component={motion.div}
          sx={{
            fontFamily: "inherit",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 2,
          }}
          initial={{ x: -100, opacity: 0 }}
          whileInView={{
            x: 0,
            opacity: 1,
            transition: { duration: 0.2, delay: 0.6 },
          }}
        >
          <PhoneAndroidIcon fontSize="small" />
          <Link href={`tel:${contactConstants?.phone}`} underline="hover">
            {contactConstants?.phone}
          </Link>
        </Typography>
        <Typography
          variant="body2"
          textAlign="justify"
          component={motion.div}
          sx={{
            fontFamily: "inherit",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 2,
          }}
          initial={{ x: -100, opacity: 0 }}
          whileInView={{
            x: 0,
            opacity: 1,
            transition: { duration: 0.2, delay: 0.8 },
          }}
        >
          <EmailIcon fontSize="small" />
          <Link href={`mailto:${contactConstants?.email}`} underline="hover">
            {contactConstants?.email}
          </Link>
        </Typography>
        <Typography
          variant="body2"
          textAlign="justify"
          component={motion.div}
          sx={{
            fontFamily: "inherit",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 2,
          }}
          initial={{ x: -100, opacity: 0 }}
          whileInView={{
            x: 0,
            opacity: 1,
            transition: { duration: 0.2, delay: 1 },
          }}
        >
          <EmailIcon fontSize="small" />
          <Link href={`tel:${contactConstants?.p_email}`} underline="hover">
            {contactConstants?.p_email}
          </Link>
        </Typography>
      </Stack>
      <Box
        width={{ xs: "290px", md: "700px" }}
        height={{ xs: "300px", md: "400px" }}
        component={motion.div}
        initial={{ scale: 0 }}
        ml={1}
        whileInView={{
          scale: 1,
          transition: { duration: 0.5, delay: 0.5 },
        }}
      >
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.668216826286!2d73.86871127423684!3d18.498681882590624!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bfe261b2357d%3A0x218828460c50dfa7!2sSt.%20Xavier&#39;s%20School%2C%20Pune!5e0!3m2!1sen!2sin!4v1719210193034!5m2!1sen!2sin"
          width="100%"
          height="100%"
        ></iframe>
      </Box>
    </Stack>
  );
};

export default ContactUs;
